//for logged in users 
import React from 'react'

function AppLayout({children}) {
  return (
    <div className='app_layout' >
      {children}
    </div>
  )
}

export default AppLayout
